import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { List, Map, fromJS } from "immutable";
import { formatCurrency } from "../util/number.js";
import { createSelector } from "reselect";
export function rentObjectsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case "RENT_OBJECTS/RENT_OBJECTS_LOADING":
      return _objectSpread(_objectSpread({}, state), {}, {
        classifications: null,
        rentObjects: null
      });
    case "RENT_OBJECTS/RENT_OBJECTS_LOADED":
      return _objectSpread(_objectSpread({}, state), {}, {
        classifications: action.payload.classifications,
        rentObjects: action.payload.rentObjects
      });
    default:
      return state;
  }
}
var getRawRentObjects = function getRawRentObjects(state) {
  var _state$rent_objects;
  return (_state$rent_objects = state.rent_objects) === null || _state$rent_objects === void 0 ? void 0 : _state$rent_objects.rentObjects;
};
var getRawClassifications = function getRawClassifications(state) {
  var _state$rent_objects2;
  return (_state$rent_objects2 = state.rent_objects) === null || _state$rent_objects2 === void 0 ? void 0 : _state$rent_objects2.classifications;
};
var getRentObjects = createSelector([getRawRentObjects], function (rentObjects) {
  return rentObjects ? fromJS(rentObjects) : List();
});
var getClassifications = createSelector([getRawClassifications], function (classifications) {
  return classifications ? fromJS(classifications) : List();
});
var getClassificationsById = createSelector([getClassifications], function (classifications) {
  return Map(classifications.map(function (c) {
    return [c.get("id"), c];
  }));
});
var rentObjectClassificationId = function rentObjectClassificationId(rentObject) {
  return rentObject === null || rentObject === void 0 ? void 0 : rentObject.getIn(["classification4", "id"]);
};
var rentObjectDescription = function rentObjectDescription(rentObject) {
  return (rentObject === null || rentObject === void 0 ? void 0 : rentObject.getIn(["classification4", "wwwDescr"])) || (rentObject === null || rentObject === void 0 ? void 0 : rentObject.getIn(["classification4", "shortDescr"]));
};
var rentObjectFormattedBaseCost = function rentObjectFormattedBaseCost(rentObject) {
  return formatCurrency(Number(rentObject.get("baseCost"))) || undefined;
};
export var getProcessedRentObjects = createSelector([getRentObjects, getClassificationsById], function (rentObjects, classifications) {
  var result = rentObjects
  // inline classification objects
  .map(function (rentObject) {
    return rentObject.set("classification4", classifications.get(rentObject.get("classific4"))).set("classification11", classifications.get(rentObject.get("classific11")));
  })

  // remove rentObjects that don't have valid classific4 and classific11 references
  .filter(function (rentObject) {
    return rentObject.get("classification4") && rentObject.get("classification11");
  })

  // inline classification properties
  .map(function (rentObject) {
    return rentObject.set("classificationId", rentObjectClassificationId(rentObject)).set("description", rentObjectDescription(rentObject)).set("formattedBaseCost", rentObjectFormattedBaseCost(rentObject));
  })

  // remove rentObjects with incomplete data
  .filter(function (rentObject) {
    return rentObject.get("classificationId") !== undefined && rentObject.get("description") !== undefined;
  });
  return result;
});